import { gql } from '@apollo/client';

export const SAVE_VISUALIZATION_PRESET_MUTATION = gql`
  mutation SaveVisualizationPresetMutation(
    $id: ID
    $name: String!
    $definitions: [FindVisualizationDefinitionInput!]!
  ) {
    saveVisualizationPreset(
      id: $id
      name: $name
      definitions: $definitions
    ) {
      __typename
      ... on SaveVisualizationPresetSuccess {
        preset {
          id
          name
          createdAt
          updatedAt
          definitions {
            id
            filter {
              materials
              eras
              findTypes
              tags
            }
            style {
              shape
              primaryColor
              secondaryColor
              sizeScale
              outlined
            }
          }
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
